import logger from '@/layers/support/monitoring/logger';
import { SponsorProfile } from '@/types/models';
import { NewSponsorRequest } from '@/types/sponsors';
import { fetchWrapper } from '../utils/fetchWrapper';

const LOG_MODULE = 'FE [Presentation / Services / Sponsors]';

const API_URL = '/api/users/sponsors';

export const fetchSponsorByUserId = async (id: string): Promise<SponsorProfile> => {
  logger.debug(`${LOG_MODULE} fetchSponsorByUserId: begin`, { id });

  try {
    const result = await fetchWrapper.get<SponsorProfile>(`${API_URL}/user/${id}`);

    logger.debug(`${LOG_MODULE} fetchSponsorByUserId: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchSponsorByUserId`, { error });
    throw error;
  }
};

export const createSponsorByUserId = async (
  sponsor: NewSponsorRequest,
): Promise<SponsorProfile> => {
  logger.debug(`${LOG_MODULE} createSponsor: begin`, { sponsor });

  try {
    const result = await fetchWrapper.put<SponsorProfile>(
      `${API_URL}/user/${sponsor.user_id}`,
      sponsor,
    );

    logger.debug(`${LOG_MODULE} createSponsor: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} createSponsor`, { error });
    throw error;
  }
};
